import React from 'react';
import Button from '../button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        role="alert"
        style={{
          padding: '48px 24px',
          textAlign: 'center',
          maxWidth: 480,
          margin: '64px auto',
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
          Something went wrong
        </div>
        <div style={{ fontSize: 14, color: '#6B778C', lineHeight: 1.6, marginBottom: 16 }}>
          An unexpected error occurred. Try again, or refresh the page if it keeps happening.
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <Button variant="subtle" showLogo={false} onClick={this.handleReset}>
            Try again
          </Button>
          <Button variant="primary" showLogo={false} onClick={this.handleReload}>
            Reload page
          </Button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
